<ex-button *ngIf="!tendersActionService.selection" icon="dots-three-outline-fill"
           (click)="tendersActionService.toggle(true)"
/>
<ex-button *ngIf="tendersActionService.selection" icon="x" type="secondary" variant="tonal"
           (click)="tendersActionService.toggle(false)" />
